import { useEffect } from 'react';
import { Col, Row } from 'reactstrap';
import { ThemedComponent } from 'ui/theme';
import { FormContent } from './styled';

export default function ContainerLandPageDist({ children, center }) {
  useEffect(() => window.scrollTo(0, 0), []);

  return (
    <ThemedComponent>
      <Row className="noPadding">
        <Col md={{ size: 12 }} className="noPadding">
          <FormContent center={center}>{children}</FormContent>
        </Col>
      </Row>
    </ThemedComponent>
  );
}
